function registerBackInStock() {
  const bisTriggers = [...document.querySelectorAll(".bis-trigger")];
  const bisWrapper = document.querySelector(".bis-popup-wrapper");
  const bisBackdrop = document.querySelector(".bis-backdrop");

  if (bisBackdrop != null) {
    bisBackdrop.addEventListener("click", function () {
      bisWrapper.classList.remove("visible");
      document.querySelector(".bis-popup__success").classList.remove("visible");
      bisTriggers.forEach((bisTrigger) => {
        bisTrigger.classList.remove("pop-up-active");
      });
    });
  }

  if (bisWrapper != null) {
    bisWrapper.addEventListener("click", function (e) {
      let isInPopup = false;

      if (e.path) {
        e.path.forEach((p) => {
          if (p.className && p.className.includes("bis-popup-modal")) {
            isInPopup = true;
          }
        });

        if (!isInPopup) {
          bisWrapper.classList.remove("visible");
          bisTriggers.forEach((bisTrigger) => {
            bisTrigger.classList.remove("pop-up-active");
          });
        }
      }
    });
  }

  bisTriggers.forEach((bisTrigger) => {
    bisTrigger.addEventListener("click", function (e) {
      bisTrigger.classList.add("pop-up-active");
      const productTitle =
        document.querySelector(".h1-product-title")?.innerHTML ||
        document
          .querySelector(".pop-up-active")
          ?.getAttribute("data-product-title");
      if (productTitle) {
        document.querySelector(".bis-popup__title.product__title").innerHTML =
          productTitle;
      }
      bisWrapper.classList.add("visible");
    });
  });

  const bisCloseTrigger = document.querySelector(".bis-popup__close");

  if (bisCloseTrigger != null) {
    bisCloseTrigger.addEventListener("click", function () {
      bisWrapper.classList.remove("visible");
      document.querySelector(".bis-popup__success").classList.remove("visible");
      bisTriggers.forEach((bisTrigger) => {
        bisTrigger.classList.remove("pop-up-active");
      });
    });
  }

  const bisSignupTrigger = document.querySelector(".bis-signup-trigger");

  if (bisSignupTrigger != null) {
    bisSignupTrigger.addEventListener("click", function (e) {
      const errorField = document.querySelector(".bis-popup__error");
      errorField.innerHTML = "";

      const email = document.querySelector(
        '.bis-popup input[type="email"]'
      )?.value;
      const productId = document
        .querySelector("form:has(.pop-up-active) input[name='product-id']")
        .getAttribute("value");
      const variantId = document
        .querySelector("form:has(.pop-up-active) input[name='id']")
        .getAttribute("value");
      const subscribeToNewsletter = document.querySelector(
        ".bis-popup #subscribe_for_newsletter"
      ).checked;

      if (email == null || !email.includes("@")) {
        errorField.innerHTML = window.bisStrings.emailErrorText;
        return;
      }

      const data = {
        // UPDATE KLAVIYO LIST ID HERE
        a: "KG2Qr9",
        email: email,
        variant: variantId,
        product: productId,
        platform: "shopify",
        subscribe_for_newsletter: subscribeToNewsletter,
      };

      fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
        method: "POST",
        headers: {
          accept: "application/json, text/plain, */*",
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: new URLSearchParams(data),
      })
        .then((response) => {
          const content = response.json();
          document
            .querySelector(".bis-popup__success")
            .classList.add("visible");
        })
        .catch((error) => {
          console.log(error);
          errorField.innerHTML = window.bisStrings.signupErrorText;
          // TODO: Handle error
        });
    });

    // Prevent enter key from refreshing the page
    const emailInput = document.querySelector(
      '.bis-email-wrapper input[type="email"]'
    );
    if (emailInput) {
      emailInput.addEventListener("keypress", function (e) {
        if (e.key === "Enter") {
          e.preventDefault();
          bisSignupTrigger.click();
        }
      });
    }
  }
}

registerBackInStock();

window.addEventListener("products:loaded", () => {
  registerBackInStock();
});
